import { Fragment, useMemo } from 'react';
import { AbsoluteFill, useCurrentFrame } from 'remotion';
import TrackComponent from '../components/TrackComponent/TrackComponent';
import { CompositionConfig } from './types/CompositionConfig';
import { getTrackZIndex } from './utils/trackUtils';
import { useRemotionEnvVariables } from './ClipPlayerV2WithNewTimeline/hooks/useRemotionEnvVariables';
import { TrackType } from './types/Track/Type';
import { ElementsTrack } from './types/Track/ElementsTrack';

const MainPlayer: React.FC<CompositionConfig> = ({
  playerConfig: { tracks },
  showPlayerFrames = false,
  onOutlineRelease,
  onOutlineResize,
  canEditCaptions = true,
  disableCaptionsDragging = false,
  disableCaptionsResize = true,
  canEditSpeakerLabel = false,
  canEditImages = false,
  canEditTextElements = false,
  canEditVideos = false,
  canManuallyReposition = false,
  preventOverlappingWithOtherCrops = false,
  canEditLottie = false
}) => {
  const frame = useCurrentFrame();
  const { burnFrameNumberInRenderOutput } = useRemotionEnvVariables();

  const elementTracks = useMemo(
    () => tracks.filter((t): t is ElementsTrack => t.type === TrackType.ELEMENTS),
    [tracks]
  );

  return (
    <Fragment>
      <AbsoluteFill
        id="remotion-main-player"
        className="content-lab-root pointer-events-none antialiased"
        style={{ containerType: 'size' }}
      >
        {tracks.map((track, index) => {
          if (track.hideTrack.inPlayer) {
            return null;
          }

          return (
            <div
              key={track.id}
              style={{
                zIndex: getTrackZIndex(track, index, tracks)
              }}
            >
              <TrackComponent
                track={track}
                elementTracks={track.type === TrackType.CAPTIONS ? elementTracks : undefined}
                onOutlineRelease={onOutlineRelease}
                onOutlineResize={onOutlineResize}
                canEditCaptions={canEditCaptions}
                disableCaptionsDragging={disableCaptionsDragging}
                disableCaptionsResize={disableCaptionsResize}
                canEditSpeakerLabel={canEditSpeakerLabel}
                canEditImages={canEditImages}
                canEditTextElements={canEditTextElements}
                canEditVideos={canEditVideos}
                canManuallyReposition={canManuallyReposition}
                preventOverlappingWithOtherCrops={preventOverlappingWithOtherCrops}
                canEditLottie={canEditLottie}
              />
            </div>
          );
        })}
      </AbsoluteFill>
      {(showPlayerFrames || burnFrameNumberInRenderOutput) && (
        <div style={{ position: 'fixed', top: 0, left: 0, color: 'red', fontSize: 60 }}>{frame}</div>
      )}
    </Fragment>
  );
};

export default MainPlayer;
